export const bedroomsInitalState = [
  {
    value: '1',
    selected: false
  },
  {
    value: '2',
    selected: false
  },
  {
    value: '3',
    selected: false
  },
  {
    value: '4',
    selected: false
  },
  {
    value: '5',
    selected: false
  }
];

export const allBedroomsSelectedState = [
  {
    value: '1',
    selected: true
  },
  {
    value: '2',
    selected: true
  },
  {
    value: '3',
    selected: true
  },
  {
    value: '4',
    selected: true
  },
  {
    value: '5',
    selected: true
  }
];

export const houseStylesInitalState = [
  {
    label: 'Detached',
    value: 'detached',
    selected: false
  },
  {
    label: 'Semi Detatched',
    value: 'semi',
    selected: false
  },
  {
    label: 'Terrace',
    value: 'terrace',
    selected: false
  },
  {
    label: 'Bunaglow',
    value: 'bungalow',
    selected: false
  },
  {
    label: 'Apartment',
    value: 'apartment',
    selected: false
  }
];

export const allHouseStylesSelectedState = [
  {
    label: 'Detached',
    value: 'detached',
    selected: true
  },
  {
    label: 'Semi Detatched',
    value: 'semi',
    selected: true
  },
  {
    label: 'Terrace',
    value: 'terrace',
    selected: true
  },
  {
    label: 'Bunaglow',
    value: 'bungalow',
    selected: true
  },
  {
    label: 'Apartment',
    value: 'apartment',
    selected: true
  }
];

export const distanceOptions = [1, 5, 10,15, 20, 30, 40, 50, 60, 70, 80, 90, 100];
export const priceOptions = [100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000, 900000, 1000000, 1250000, 1500000, 1750000, 2000000];